import { render, staticRenderFns } from "./ModalModifyDocument.vue?vue&type=template&id=432c8468"
import script from "./ModalModifyDocument.vue?vue&type=script&lang=js"
export * from "./ModalModifyDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports